// Private
import { pluralize } from '@/utils/language-service';
import { isTileElement } from './element-service';

// Public
const getContextualVirtualNodeTitle = (service) => (service ? `Get contextual data from ${service.service_name}` : 'Contextual Data');

const getPluralizeItemNameIfNeeded = (placement) => (placement.pluralize_item_name ? pluralize(placement.item_name) : placement.item_name);

/**
 * [null, 'deal', null] === 'deal'
 *
 * [null, 'deal', '- actions'] === 'deal - actions'
 *
 * ['the', 'compose section', null] === 'the compose section'
 */
const getFullItemName = (placement) =>
	[placement.item_name_prefix, getPluralizeItemNameIfNeeded(placement), placement.item_name_suffix].filter((p) => !!p).join(' ');

const getAddOnType = (placement, elementType) =>
	isTileElement(elementType) ? 'tile' : placement.is_piggyback ? 'on-send checkbox' : elementType || 'button';
const getAddOnIcon = (placement, elementType) =>
	isTileElement(elementType) ? 'sidebar' : placement.is_piggyback ? 'checkbox' : 'touching-finger';

const PlacementService = { getContextualVirtualNodeTitle, getFullItemName, getAddOnType, getAddOnIcon };

export default PlacementService;
